
let OrderRoutes = [
  {
    // 订餐参数
    path: '5000',
    name: '5000',
    component: () => import('@/pages/Order/OrderParamter/OrderParamter')
  },
  {
    // 菜品类型
    path: '5101',
    name: '5101',
    component: () => import('@/pages/Order/DishesTypeManage/DishesTypeManage')
  },
  {
    // 菜品信息
    path: '5201',
    name: '5201',
    component: () => import('@/pages/Order/DishesManage/DishesManage')
  },
  {
    // 套餐管理
    path: '5301',
    name: '5301',
    component: () => import('@/pages/Order/MealPackageManage/MealPackageManage')
  },
  {
    // 菜单管理
    path: '5401',
    name: '5401',
    component: () => import('@/pages/Order/FoodMenu/FoodMenu')
  },
  {
    // 菜单使用设置
    path: '5501',
    name: '5501',
    component: () => import('@/pages/Order/MenuSetting/MenuSetting')
  },
  {
    // 菜单日历
    path: '5502',
    name: '5502',
    component: () => import('@/pages/Order/MenuCalendar/MenuCalendar')
  },
  {
    // 团餐管理
    path: '5601',
    name: '5601',
    component: () => import('@/pages/Order/GroupOrder/GroupOrder')
  },
  {
    // 团餐统计
    path: '5605',
    name: '5605',
    component: () => import('@/pages/Order/StatisticGroupOrder/reportinfo')
  },
  {
    // 订餐明细查询
    path: '5701',
    name: '5701',
    component: () => import('@/pages/Order/OrderMealDetailReport/OrderMealDetailReport')
  },
  {
    // 套餐备餐统计查询
    path: '5702',
    name: '5702',
    component: () => import('@/pages/Order/StatisticOrderMealReport/StatisticOrderMealReport')
  },
  {
    // 菜品备餐统计查询
    path: '5705',
    name: '5705',
    component: () => import('@/pages/Order/FoodOrderReport/FoodOrderReport')
  },
  {
    // 取餐统计查询
    path: '5703',
    name: '5703',
    component: () => import('@/pages/Order/TakeFoodReport/TakeFoodReport')
  }
]

export {
  OrderRoutes
}



// WEBPACK FOOTER //
// ./src/router/OrderRoutes.js